import {
  PersistQueryClientProvider,
  PersistQueryClientProviderProps,
} from '@tanstack/react-query-persist-client'
import React, { createContext, useContext } from 'react'
import {
  MAX_QUERY_CACHE_AGE,
  mmkvPersister,
  queryClientInstance,
} from './query_client_instance'

export type CustomPersistQueryClientContextValue =
  PersistQueryClientProviderProps

export const CustomPersistQueryClientContext = createContext(
  {} as CustomPersistQueryClientContextValue
)

interface Props {
  children: React.ReactNode
}

export function CustomPersistQueryClientProvider(props: Props) {
  const persistQueryClientProviderProps: PersistQueryClientProviderProps = {
    client: queryClientInstance,
    persistOptions: {
      persister: mmkvPersister,
      maxAge: MAX_QUERY_CACHE_AGE,
    },
  }

  return (
    <PersistQueryClientProvider {...persistQueryClientProviderProps}>
      {props.children}
    </PersistQueryClientProvider>
  )
}

export function useCustomPersistQueryClientContext() {
  return useContext<CustomPersistQueryClientContextValue>(
    CustomPersistQueryClientContext
  )
}
